import { createContext, ReactNode, useState } from "react";

import { ICompany } from "@@types/ICompany";

interface CompanyContextData {
  currentCompany: ICompany | undefined;
  setCurrentCompany: React.Dispatch<React.SetStateAction<ICompany | undefined>>;
  showSummaryValues: boolean;
  setShowSummaryValues: React.Dispatch<React.SetStateAction<boolean>>;
}

export const CompanyContext = createContext({} as CompanyContextData);

interface CompanyProviderProps {
  children: ReactNode;
}

export function CompanyProvider({ children }: CompanyProviderProps) {
  const [currentCompany, setCurrentCompany] = useState<ICompany | undefined>(undefined);
  const [showSummaryValues, setShowSummaryValues] = useState<boolean>(true);

  return (
    <CompanyContext.Provider
      value={{
        currentCompany,
        setCurrentCompany,
        showSummaryValues,
        setShowSummaryValues,
      }}
    >
      {children}
    </CompanyContext.Provider>
  );
}
